import $ from 'jquery'
import { loadComponents, removeComponents } from './componentUtils'

export default class Snippet {

    constructor(element) {
        this.$element = $(element)
        this.element = element

        this.$element.data('_snippet', this)
    }

    removeComponents(element) {
        removeComponents($(element)[0])
    }

    loadComponents(element) {
        loadComponents($(element)[0])
    }

    beforeUpdate() {}

    afterUpdate() {}

    update({ html, append, back, payload }) {
        const $el = this.$element
        this.beforeUpdate({
            html,
            append,
            back,
            payload,
            component: payload?.component
        })

        if (!back && ($el.is('[data-ajax-append]') || ($el.attr('id') == append))) {
            $el.append(html)
        } else if (!back && $el.is('[data-ajax-prepend]')) {
            $el.prepend(html)
        } else if ($el.html() != html) {
            this.removeComponents($el)
            $el.html(html)
        }

        this.loadComponents($el)

        this.afterUpdate({
            html,
            append,
            back,
            component: payload.component,
            payload
        })
    }

}